import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    pure: false
})

export class FilterPipe implements PipeTransform {
    transform(items: any[], term?:string, multiselectIds?:string[]): any {
        if(!term)return items;

        const normalizedTerm = term.toLowerCase();
        let list =  items.filter(item => (item.name && item.name.toLowerCase().indexOf(normalizedTerm) !== -1)  ||
        (item.nameAr && item.nameAr.toLowerCase().indexOf(normalizedTerm) !== -1) ||
        (multiselectIds && multiselectIds?.includes(item.id)));
        return list;
    }
}
